export const routerMixin = {
  beforeRouteLeave (to, from, next) {
    this.$emit('before-route-leave');
    next()
  },
}